"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../styles");

var styles = {
  root: {
    width: function width(_ref) {
      var rangedDates = _ref.rangedDates;
      return rangedDates ? '600px' : '270px';
    },
    border: "1px solid ".concat(_styles.colors.gray),
    borderRadius: '3px'
  },
  calendarIcon: {
    height: '15px',
    width: '15px',
    cursor: 'pointer',
    transition: 'all 0.3s'
  },
  calendarIconActive: {
    fill: _styles.colors.blue
  },
  calendarIconInvalid: {
    fill: _styles.colors.red
  },
  header: {
    background: _styles.colors.charcoal,
    color: _styles.colors.white,
    userSelect: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'center',
    height: '45px',
    padding: '0 10px',
    borderRadius: '3px 3px 0 0'
  },
  pointerArrow: {
    fill: _styles.colors.white,
    cursor: 'pointer',
    height: '30px',
    width: '30px',
    padding: '7px'
  },
  yearMenuToggler: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    flexShrink: 0,
    '& > *': {
      flexShrink: 0
    }
  },
  caret: {
    fill: _styles.colors.white,
    height: '10px',
    width: '10px',
    marginLeft: '10px',
    transition: 'transform 0.5s'
  },
  caretFlipped: {
    transform: 'rotate(-180deg)'
  },
  calendarView: {
    background: _styles.colors.white
  },
  timePickers: {
    borderBottom: "1px solid ".concat(_styles.colors.gray)
  },
  disableTimePickers: {
    opacity: 0.5,
    pointerEvents: 'none'
  },
  rangedDatesHeaderHalf: {
    width: '50%',
    display: 'flex',
    alignItems: 'center'
  },
  rangedDatesHeaderText: {
    margin: '0 auto'
  },
  rangedCalendars: {
    display: 'flex',
    borderBottom: "1px solid ".concat(_styles.colors.gray)
  },
  rangedCalendarHalf: {
    width: '50%',
    height: '250px',
    margin: '10px 15px'
  },
  rangedDatesTimePickers: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly'
  },
  actions: {
    height: '55px',
    padding: '0 15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > *': {
      margin: '0 5px'
    }
  }
};
var _default = styles;
exports["default"] = _default;